module.exports = __webpack_public_path__ + "img/01-light.d099ecc9.png";